/** Глобальное окно «Закрепить чат за колонками» — открывается с карточки, из панели карточки или из списка чатов. */
import { ref } from 'vue';

export interface PinPrompt {
  chatId: string;
  chatTitle: string;
  /** Текущая колонка карточки — предлагаем её, если чат ещё не закреплён. */
  suggestedColumn: string | null;
  /** Колонки, за которыми чат закреплён сейчас. */
  pinnedColumns: string[];
  /** Вызывается после успешного сохранения (например, перечитать список). */
  onDone?: (pinnedColumns: string[]) => void;
}

export const pinPrompt = ref<PinPrompt | null>(null);

export function openPinDialog(p: PinPrompt) {
  pinPrompt.value = p;
}
